export enum AuthenticationMethod {
  EmailAndPassword = '1',
  Google = '2',
  Microsoft = '3',
}
